import { render, staticRenderFns } from "./Opz2DaysPane.vue?vue&type=template&id=d71c5c32"
import script from "./Opz2DaysPane.vue?vue&type=script&lang=ts"
export * from "./Opz2DaysPane.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports